import { useState } from 'react'
import {Mail, Send} from 'lucide-react'
import toast from 'react-hot-toast'
import Breadcrumbs from '@/components/Breadcrumbs'
import SectionHeading from '@/components/ui/SectionHeading'
import Seo from '@/components/Seo'
import { breadcrumbSchema } from '@/lib/schema'

function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!name || !email || !message) {
      toast.error('Please fill in all fields')
      return
    }
    toast.success('Message sent! We will get back to you shortly.')
    setName('')
    setEmail('')
    setMessage('')
  }

  return (
    <>
      <Seo
        title="Contact Us"
        description="Get in touch with the Mint Calculator team for feedback, bug reports, partnership inquiries, or general questions about our free financial calculator suite."
        path="/contact"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }]} />
        <SectionHeading title="Contact Us" description="Questions, feedback, or partnership inquiries — we would love to hear from you." />

        <div className="mt-8 flex items-center gap-3 rounded-xl border border-slate-800 bg-slate-900/50 p-4">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-400">
            <Mail className="h-4 w-4" />
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-100">Email us directly</p>
            <p className="text-sm text-slate-500">support@mintcalculator.com</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4 rounded-xl border border-slate-800 bg-slate-900/50 p-5">
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-slate-300">Name</span>
            <input
              value={name}
              onChange={e => setName(e.target.value)}
              className="w-full rounded-lg border border-slate-700 bg-slate-800/60 px-3 py-2.5 text-sm text-slate-50 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20"
              placeholder="Jane Doe"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-slate-300">Email</span>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full rounded-lg border border-slate-700 bg-slate-800/60 px-3 py-2.5 text-sm text-slate-50 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20"
              placeholder="jane@example.com"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-slate-300">Message</span>
            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              rows={5}
              className="w-full rounded-lg border border-slate-700 bg-slate-800/60 px-3 py-2.5 text-sm text-slate-50 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20"
              placeholder="How can we help?"
            />
          </label>
          <button type="submit" className="flex items-center gap-2 rounded-lg bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-slate-950 transition-colors hover:bg-emerald-400">
            <Send className="h-4 w-4" />
            Send Message
          </button>
        </form>
      </div>
    </>
  )
}

export default Contact
